// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"Icon__icon--3xS-f"};